<template>
    <div>
        <Loading :value="loading"></Loading>
        <!-- RACOURCIS -->
        <v-layout row class="text-xs-center">
            <!-- Graph -->
            <v-flex xs6></v-flex>

            <v-flex xs6></v-flex>
        </v-layout>

        <v-layout row>
            <!--PREVISION BUDGETAIRE-->
            <!--PREVISION BUDGETAIRE-->
            <v-flex xs12>
                <v-layout row>
                    <v-card style="width:100%">
                        <v-card-text fluid grid-list-md>
                            <h3>Prévision du budget</h3>
                            <v-divider class="mb-2"></v-divider>
                             <v-layout row>
                                <v-flex xs4>
                                    <v-chip style="font-size:15px" label outline
                                            color="primary"><b>TOTAL TRAVAUX EN ATTENTE DE VALIDATION
                                        : {{ new
                                        Intl.NumberFormat().format(totalTravauxEnAttente)
                                        }} </b></v-chip>
                                </v-flex>
                                <v-flex xs4>
                                    <v-chip style="font-size:15px" label outline
                                            color="primary"><b>TOTAL MONTANT PROPOSE
                                        : {{ new
                                        Intl.NumberFormat().format(totalMntPropose)
                                        }} </b></v-chip>
                                </v-flex>

                                <v-flex xs4>
                                    <v-chip style="font-size:15px" label outline
                                            color="primary"><b>TOTAL MONTANT VALIDE
                                        : {{ new
                                        Intl.NumberFormat().format(totalMntValide)
                                        }} </b></v-chip>
                                </v-flex>
                            </v-layout>
                            <v-layout row class="mb-4 mt-2">
                                <v-flex xs12 class="mt-2">
                                    <data-tables
                                            :data="tableListeTrxBudget"
                                            style="width: 100%">
                                        <!--expand-->
                                        <el-table-column type="expand">
                                            <template slot-scope="props">
                                                <el-row class="elevation-3 pl-4 pr-4 pt-2"  >
                                                    <el-col :span="24">
                                                        <div class="grid-content bg-purple mb-2">
                                                            <v-alert
                                                                    :value="true"
                                                                    outline
                                                                    color="primary"
                                                                    class="mb-4"
                                                                    icon="info"
                                                            >Detail du budget
                                                            </v-alert>
                                                            <!--<div>-->
                                                                <!--<v-flex md3 class="mr-1">-->
                                                                    <!--<el-form  :label-position="labelPosition">-->
                                                                        <!--<el-form-item label="Filtrer par année et mois"  style="width:100%">-->
                                                                            <!--<el-date-picker-->
                                                                                    <!--format="MMMM-yyyy"-->
                                                                                    <!--value-format="yyyy-MM"-->
                                                                                    <!--v-model="dateAnMois"-->
                                                                                    <!--type="month" id="dateMoisAn"-->
                                                                                    <!--placeholder="Sélectionnez un mois"-->
                                                                                    <!--style="width:100%">-->
                                                                            <!--</el-date-picker>-->
                                                                        <!--</el-form-item>-->
                                                                    <!--</el-form>-->
                                                                <!--</v-flex>-->
                                                            <!--</div>-->
                                                            <div>

                                                                <el-table
                                                                        border
                                                                        highlight-current-row
                                                                        :header-row-style="headerRowStyle"
                                                                        :data="props.row.detailBudget"
                                                                        :summary-method="getSumm"
                                                                        show-summary
                                                                        style="width: 100%"
                                                                >
                                                                    <el-table-column
                                                                            align="center"
                                                                            prop="libelle"
                                                                            label="DESIGNATION">
                                                                    </el-table-column>
                                                                    <el-table-column
                                                                            align="center"
                                                                            prop="montantPropose"
                                                                            label="MONTANT PROPOSE">
                                                                        <template slot-scope="scope">
                                                                            {{new Intl.NumberFormat().format(scope.row.montantPropose)}}
                                                                        </template>
                                                                    </el-table-column>
                                                                    <el-table-column
                                                                            align="center"
                                                                            prop="montantValide"
                                                                            label="MONTANT VALIDE">
                                                                        <template slot-scope="scope">
                                                                            {{new Intl.NumberFormat().format(scope.row.montantValide)}}
                                                                        </template>
                                                                    </el-table-column>
                                                                    <el-table-column
                                                                            align="center"
                                                                            prop="mois"
                                                                            label="MOIS">

                                                                    </el-table-column>
                                                                </el-table>
                                                            </div>

                                                        </div>
                                                    </el-col>
                                                </el-row>
                                            </template>
                                        </el-table-column>
                                        <!--expand-->

                                        <el-table-column
                                                label="Travaux"
                                                prop="libelle">
                                        </el-table-column>
                                        <el-table-column
                                                label="montant proposé"
                                                prop="mntBudgetPropose">
                                            <template slot-scope="scope">
                                                {{new Intl.NumberFormat().format(scope.row.mntBudgetPropose)}}
                                            </template>
                                        </el-table-column>

                                        <el-table-column
                                                label="montant validé"
                                                prop="mntBudgetValide">
                                            <template slot-scope="scope">
                                                {{new Intl.NumberFormat().format(scope.row.mntBudgetValide)}}
                                            </template>
                                        </el-table-column>

                                        <el-table-column
                                                prop="etat">
                                            <template slot-scope="scope">
                                                <el-tag
                                                        :type="scope.row.etat == 1 ?  'success':'warning'"
                                                        disable-transitions>{{scope.row.libEtat}}</el-tag>
                                            </template>
                                        </el-table-column>

                                        <el-table-column
                                                label="Action"
                                                prop="action">
                                            <template slot-scope="scope">
                                                <v-tooltip top>
                                                    <v-btn
                                                            v-if="scope.row.etat == 3 "
                                                            slot="activator"
                                                            @click="modalAjoutBudget(scope.row)"
                                                            fab
                                                            dark
                                                            small
                                                            color="blue"
                                                    >
                                                        <v-icon dark>add</v-icon>
                                                    </v-btn>Etablir le budget
                                                </v-tooltip>

                                                <v-tooltip top>
                                                    <v-btn
                                                            v-if="scope.row.etat == 0"
                                                            slot="activator"
                                                            @click="modalAjoutBudget(scope.row)"
                                                            fab
                                                            dark
                                                            small
                                                            color="orange"
                                                    >
                                                        <v-icon dark>edit</v-icon>
                                                    </v-btn>Modifer le budget
                                                </v-tooltip>
                                            </template>
                                        </el-table-column>
                                    </data-tables>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-layout>
            </v-flex>
            <!--PREVISION BUDGETAIRE-->
        </v-layout>

        <!--IMPORT-->
        <AjoutPrevisionBudget :show="showModalAjoutPrevision" :typeTrx="typeTravaux" :idProjet="projet.id" @close="showModalAjoutPrevision = false;loadListeTravaux()" ></AjoutPrevisionBudget>
    </div>
</template>

<script>
    //function de difference de date

    var echarts = require("echarts/lib/echarts");
    require("echarts/lib/chart/bar");
    require("echarts/lib/chart/pictorialBar");
    require("echarts/lib/chart/funnel");
    require("echarts/lib/chart/sankey");
    require("echarts/lib/chart/scatter");
    require("echarts/lib/component/tooltip");
    require("echarts/lib/component/title");
    import html2canvas from "html2canvas";
    import Loading from "@/components/Loading";
    import AjoutPrevisionBudget from '@/components/projet/AjoutPrevisionBudget';

    export default {
        components: {
            Loading,
            AjoutPrevisionBudget
        },
        props:{
            show:{
                type: Boolean
            },
            projet: {
                type: Object
            }
        },
        name: "CompteExploitationProjet",
        data() {
            return {
                //data general
                notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
                domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
                user: JSON.parse(sessionStorage.getItem("userInfo")),
                roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
                droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
                loading: false,


                //VARIABLE
                tableListeTrxBudget:[],
                idTypeTache: null,
                totalMntPropose: 0,
                totalMntValide: 0,
                totalTravauxEnAttente: 0,

                //MODAL AJOUT PREVISION
                showModalAjoutPrevision : false,
                typeTravaux: {
                    libelle: ""
                },
                dateAnMois: null,
                labelPosition: 'top'




            };
        },
        computed: {

        },
        watch:{
            show: function(newValue, oldValue){
                this.tableListeTrxBudget.splice(0);
                if(newValue == true){

                    console.log("detail projet ", this.projet)
                    this.idTypeTache = this.projet.idType
                    this.loadListeTravaux();
                }
            }
        },
        methods: {

            headerRowStyle({row, rowIndex}) {
                return {"color":"black"};
            },
            format(percentage) {
                console.log("pourcentage", percentage)
                return `${percentage}%`;
            },


            getSumm(param) {
                const {columns, data} = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = "Sous total";
                        return;
                    }

                    if (index === 4) {
                        sums[index] = "N/A";
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = new Intl.NumberFormat().format(
                            values.reduce((prev, curr) => {
                                const value = Number(curr);
                                if (!isNaN(value)) {
                                    return prev + curr;
                                } else {
                                    return prev;
                                }
                            }, 0)
                        );
                    } else {
                        sums[index] = "N/A";
                    }
                });

                return sums;
            },

            modalAjoutBudget(item){
                console.log("item ",item)
                this.typeTravaux=  item
                this.showModalAjoutPrevision = true


            },
            loadListeTravaux(){
                this.loading = true;
                console.log("projet", this.projet )

                let url =  this.domaine + "budgetProjet/typeTache/" + this.idTypeTache+"/projet/"+this.projet.id;

                this.$http.get(url).then(
                    resp=>{
                        this.loading = false;
                        console.log("response ", resp.body)
                        this.tableListeTrxBudget = resp.body.listeTypeTrx
                         this.totalMntPropose = resp.body.totalMntPropose;
                        this.totalMntValide = resp.body.totalMntValide;
                        this.totalTravauxEnAttente = resp.body.totalTravauxEnAttente;
                    },
                    error=>{
                        this.loading = false;
                        this.$message.error(
                            "Une erreur est survenue lors du chargement de la liste travaux du module compte exploitation"
                        );
                    }
                );
            },

            //recherche info projet ou chantier
            submitForm() {
            }
        },

        mounted() {

        }
    };
</script>

<style>
    tr td.el-table__expanded-cell {
        background-color:#EEEEEE;
    }



    td.el-table__expanded-cell div {
        background-color:#ffffff;
    }
</style>




// WEBPACK FOOTER //
// src/components/projet/CompteExploitationProjet.vue